import { ChallengeI18n } from "@/locales/base.message.locales";

export const challenge: ChallengeI18n = {
  prizes: "Premiações",
  loading: "Carregando desafios...",
  lives_changed: "{0} Vidas que serão mudadas",
  registration_time_to_end: "A inscrição termina em:",
  time_to_end: "Termina em:",
  registration_never_end: "Entre",
  registration_end: "Entre - Termina {0}",
  registration_end_in_days: "Entre - Termina {0} Dias",
  never_end: "Entre",
  ending_in: "Termina {0}",
  ending_in_days: "Termina {0} Dia | Termina {0} Dias",
  closed: "Fechado",
  challenges_title: "Desafios",
  challenges_finished: "Resultados",
  title: "Desafios",
  description: "Descrição",
  upload_file: "Subir arquivo",
  users: "{count} Usuário | {count} Usuários",
  enter_now: "Entrar agora",
  challenge_ended: "Desafio encerrado",
  messages: {
    no_files: "Opa! Não foi possível encontrar nenhum arquivo para este desafio.",
    no_gallery: "Oops! Não conseguimos encontrar nenhuma imagem para esse desafio.",
    add_images: "Adicione imagens ao desafio agora mesmo !",
    no_tasks: "Oops! Não conseguimos encontrar nenhuma tarefa para esse desafio.",
    register_task: "Cadastre uma tarefa agora mesmo !",
    location_failed: "Sinto muito, ocorreu um erro ao tentar enviar a localização",
    location_send: "Localização enviada com sucesso! Obrigado pela contribuição",
    related_not_founded: "Oops! Não conseguimos encontrar nenhum desafio.",
    no_challenge_forum: "Oops! Não conseguimos encontrar nenhum tópico para esse desafio.",
    no_challenge_judge: "Oops! Não conseguimos encontrar nenhum juiz para esse desafio.",
    no_challenge_partner: "Oops! Não conseguimos encontrar nenhum parceiro para esse desafio.",
    no_challenge_team: "Oops! Não conseguimos encontrar nenhum time para esse desafio.",
    no_challenge_advisers: "Oops! Não conseguimos encontrar nenhum conselheiro para esse desafio.",
    be_a_adviser: "Seja um conselheiro agora mesmo !",
    create_team: "Crie um time agora mesmo !",
    be_a_judge: "Seja um juiz agora mesmo !",
    create_topic: "Crie agora um novo tópico !",
    try_reload: "Tente recarregar a página.",
    server_error: "Opa! Algo deu errado com o nosso servidor.",
    interact_now: "Faça login e começe a interagir agora mesmo !",
    problem_location_failed: "Opa! Não foi possível enviar a localização."
  },
  buttons: {
    skills: "Habilidades",
    abort: "Recuso",
    accept: "Aceito",
    send_locale: "Enviar Localização",
    sign_in: "Entrar",
    report_problem: "Reportar problema"
  },
  labels: {
    team_enabled: "Times habilitados",
    no_challenge_registered: "Nenhum desafio cadastrado",
    no_challenge_registered_with_tag: 'Nenhum desafio cadastrado com a tag "{0}"',
    no_challenges_in_progress: "Nenhum desafio em progresso",
    no_challenges_in_progress_with_tag: 'Nenhum desafio em progresso com a tag "{0}"',
    no_challenges_finished: "Nenhum desafio finalizado",
    no_challenges_finished_with_tag: 'Nenhum desafio finalizado com a tag "{0}"',
    no_challenges_comming_soon: "Nenhum desafio em breve",
    no_challenges_comming_soon_with_tag: 'Nenhum desafio em breve com a tag "{0}"',
    locale_with_same_problem: "Localização com o mesmo problema",
    show_map: "Mostrar no Mapa",
    show_users: "Mostrar Usuarios",
    you_are_participating: "Você está participando",
    signin_to_follow: "Faça login para seguir esse desafio"
  },
  subtitles: {
    you_area_facing_this_problem: "Digite as instruções na caixa abaixo ou marque-a diretamente no mapa"
  },
  titles: {
    accept_this_challenge: "Você aceita este desafio?",
    you_area_facing_this_problem: "A sua área está enfrentando esse desafio / problema",
    follow_challenge: "Deseja seguir esse desafio ?",
    by: "Por"
  },
  tab_titles: {
    files: "Arquivos",
    teams: "Times",
    my_team: "Meu Time",
    advisers: "Conselho Consultivo ",
    timeline: "Cronograma",
    faq: "FAQ",
    judges: "Mentores",
    map: "Mapa do Desafio",
    in_progress: "Em progresso",
    finished: "Concluídos",
    coming_soon: "Em breve",
    community: "Comunidade",
    all: "Todos",
    tasks: "Tarefas",
    gallery: "Galeria de imagens",
    partners: "Parceiros"
  },
  related: "Desafios Relacionados",
  judges: "{count} Juiz | {count} Juizes",
  partners: "{count} Parceiro | {count} Parceiros",
  not_judges: "Nenhum juíz relacionado ainda",
  advisers: "{count} Conselheiro | {count} Conselheiros",
  not_advisers: "nenhum conselheiro selecionado ainda",
  advisers_description: "Conselheiro não possui informações complementares.",
  judge_description: "Juiz não possui informações complementares.",
  impactedSDGs: "ODS impactados pelo desafio",
  knowMoreAboutSDGs: "SAIBA MAIS SOBRE OS 17 ODS DA ONU",
  type: {
    competition: "Competição",
    collaborative: "Colaborativo"
  },
  accept: {
    button: "",
    text:
      "Seja um membro da Ikone - Global Social League - Seu trabalho e talento se tornarão as soluções que o mundo precisa.",
    title: "EU ACEITO DESAFIOS"
  },
  have: {
    button: "",
    text: "Compartilhe suas percepções com a Ikone - Global Social League - um desafio complexo e de mudança de vida.",
    title: "EU TENHO UM DESAFIO",
    long_description: `Muitos desafios são complexos demais para serem resolvidos sozinhos. <br/> Se você, como nós, acredita em o poder de agir em conjunto e em cooperação, envie-nos uma mensagem com detalhes sobre o desafio que você deseja resolver.`
  },
  actions: {
    abort: "Abortar Missão",
    accept: "Aceitar Desafio"
  },
  follow: {
    success: "Você agora está seguindo este Desafio!",
    error: "Ops! Houve um problema ao seguir o Desafio."
  },
  unfollow: {
    success: "Você deixou este Desafio!",
    error: "Ops! Houve um problema ao deixar de seguir o Desafio."
  },

  dialog: {
    no_profile_accept: "Para aceitar desafios, você precisa criar seu perfil de participante.",
    no_profile_follow: "Para seguir os desafios, você precisa criar seu perfil de participante.",
    redirect: "Você será redirecionado para a página de configuração de perfil.",
    accept: {
      title: "Aceitar desafio?",
      text: "Você seguirá todas as atividades deste desafio.",
      button: "Aceitar"
    },
    abort: {
      title: "Abortar missão?",
      text: "Você perderá todas as suas atividades neste desafio.",
      button: "Abortar"
    },
    post: {
      name: "Nome*",
      email: "Email*",
      phone: "Telefone*",
      country: "País*",
      category: "Sugestão de categoria*",
      message: "Descreva seu desafio*",
      button: "Enviar"
    }
  },
  search_results: "Resultados de pesquisa:"
};
